let base_url = window.location.href.includes('localhost') ? "http://localhost:80" : "";

export default base_url;


// WEBPACK FOOTER //
// ./src/base_url.js